import { QueryDocumentSnapshot } from "firebase/firestore";
import { DocumentData, DocumentSnapshot, Timestamp } from "shared/api/firebase";
import { FaqGroup, FaqGroupStatus } from "../types";

type FaqGroupDBT = {
  id: string;
  title: string;
  questionsCount: number;
  updatedAt: Timestamp;
  createdAt: Timestamp;
  status: FaqGroupStatus;
  order: number;
};

type FaqGroupDataT = Omit<FaqGroupDBT, "id">;

export class FaqGroupDB {
  id: string;
  title: string;
  updatedAt: Timestamp;
  createdAt: Timestamp;
  status: FaqGroupStatus;
  order: number;
  questionsCount: number;

  constructor(
    faqGroup: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>,
  ) {
    if (!faqGroup.exists()) {
      throw new Error(`Faq group ${faqGroup.id} does not exist`);
    }

    const data = faqGroup.data() as FaqGroupDataT;

    this.id = faqGroup.id;
    this.title = data.title;
    this.updatedAt = data.updatedAt;
    this.createdAt = data.createdAt;
    this.status = data.status;
    this.order = data.order;
    this.questionsCount = data.questionsCount;
  }

  toFaqGroup(): FaqGroup {
    return {
      id: this.id,
      title: this.title,
      updatedAt: this.updatedAt.toDate(),
      createdAt: this.createdAt.toDate(),
      status: this.status,
      order: this.order,
      questionsCount: this.questionsCount,
    };
  }
}
